/** A plain left click without modifiers: the app navigates itself; middle click and Ctrl/Cmd/Shift+click stay with the browser (new tab, window). */
export const plainClick = (event) => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
